import React from 'react'

import { Layout, Header, SectionTitle, Code } from '../../../../components'

import Iconography from './iconography'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        complete={true}
      >
        <div className="intro">
          <p>
            Icons are symbols that represent concepts, objects or actions, and
            have semantic purpose within a layout. They should always be
            recognizable, functional and easily understood.
          </p>
        </div>
        <SectionTitle>Icon Library</SectionTitle>
        <Iconography site={data.site} />
      </Layout>
    </>
  )
}
